import {
  diagram as originalDiagram,
  related,
  sourceIds,
} from './puzzles__wear-em-wash-em-laundromat.mdx';

export { sourceIds, related };

export const diagram = {
  ...originalDiagram,
  src: '/diagrams/zh/laundromat-pattern.svg',
  sourceId: 'laundromat-pattern',
  caption:
    '原创示意图：第 1–3 列可交互洗衣机全部开启；第 4–5 列全部关闭；第 6 列只开启靠门的一台。',
  alt: '第 1–3 列可交互洗衣机全部开启；第 4–5 列全部关闭；第 6 列只开启靠门的一台。',
};
export const quickAnswer =
  '第 1–3 列可交互洗衣机全部开启；第 4–5 列全部关闭；第 6 列只开启靠门的一台。';

## Wear'Em & Wash'Em 在哪里？

Wear’Em & Wash’Em 位于 Central。入口若有红色屏障，沿红色连接检查维持屏障的物件。

## 正确的洗衣机开关状态

面对洗衣机，从左向右数列。谜题看最终状态，不需要限时操作。

1. 第 1 列：开启可交互机器。
2. 第 2、3 列：各自两台可交互机器全部开启。
3. 第 4、5 列：保持关闭。
4. 第 6 列：只开启最靠近门的机器，其余保持关闭。

## 为什么墙没有打开？

第四列可能已有机器在运行，不能只检查自己刚操作的机器。第六列以门为参照，不要默认选择最上方的一台。

## Secret Hideout 奖励

正确状态会打开隐藏房间。进入后收集生命升级物品，再继续探索。
